import {Grid as MantineGrid} from '@mantine/core';

/**
 * 12-column responsive grid (with `Grid.Col`) — design-layer pass-through over Mantine `Grid`.
 * @registry Pass-through Mantine Grid; import this instead of @mantine/core outside src/design.
 */
export const Grid = MantineGrid;
